import { TStoreState } from 'redux/types';
import { EMPTY_FISCAL_REPORT_LIST, EMPTY_FISCAL_VAT_LIST_INFO_FILTER } from './constants';

export const selectFiscalReports = (state: TStoreState) => state.fiscalReports;

export const selectFiscalVatListInfoFilter = (state: TStoreState) =>
	selectFiscalReports(state).fiscalVatListInfoFilter;

export const selectFiscalVatListInfoFilterLoader = (state: TStoreState) =>
	selectFiscalReports(state).fiscalVatListInfoFilterLoader;

export const selectFiscalVatListInfoFilterData = (state: TStoreState) => {
	const fiscalVatListInfoFilter = selectFiscalVatListInfoFilter(state);
	return fiscalVatListInfoFilter?.data || EMPTY_FISCAL_VAT_LIST_INFO_FILTER;
};

export const selectFiscalVatListInfoFilterTotal = (state: TStoreState) => {
	const fiscalVatListInfoFilter = selectFiscalVatListInfoFilter(state);
	return fiscalVatListInfoFilter?.total || 0;
};

export const selectFiscalVatListInfoFilterPage = (state: TStoreState) => {
	const fiscalVatListInfoFilter = selectFiscalVatListInfoFilter(state);
	return fiscalVatListInfoFilter?.page || 1;
};

export const selectFiscalVatListInfoFilterLimit = (state: TStoreState) => {
	const fiscalVatListInfoFilter = selectFiscalVatListInfoFilter(state);
	return fiscalVatListInfoFilter?.limit || 10;
};

// New selectors for GET_FISCAL_REPORT_LIST
export const selectFiscalReportList = (state: TStoreState) =>
	selectFiscalReports(state).fiscalReportList;

export const selectFiscalReportListLoader = (state: TStoreState) =>
	selectFiscalReports(state).fiscalReportListLoader;

export const selectFiscalReportListData = (state: TStoreState) => {
	const fiscalReportList = selectFiscalReportList(state);
	return fiscalReportList?.rows || EMPTY_FISCAL_REPORT_LIST;
};

export const selectFiscalReportListTotal = (state: TStoreState) => {
	const fiscalReportList = selectFiscalReportList(state);
	return fiscalReportList?.rowCount || 0;
};

export const selectFiscalReportListPage = (state: TStoreState) => {
	const fiscalReportList = selectFiscalReportList(state);
	return fiscalReportList?.page || 1;
};

export const selectFiscalReportListLimit = (state: TStoreState) => {
	const fiscalReportList = selectFiscalReportList(state);
	return fiscalReportList?.page.size || 10;
};

// New selectors for DOWNLOAD_FISCAL_PDF
export const selectDownloadFiscalPdfLoader = (state: TStoreState) =>
	selectFiscalReports(state).downloadFiscalPdfLoader;

export const selectDownloadedFiscalPdf = (state: TStoreState) =>
	selectFiscalReports(state).downloadedFiscalPdf;

// New selectors for DOWNLOAD_FISCAL_CSV
export const selectDownloadFiscalCsvLoader = (state: TStoreState) =>
	selectFiscalReports(state).downloadFiscalCsvLoader;

export const selectDownloadedFiscalCsv = (state: TStoreState) =>
	selectFiscalReports(state).downloadedFiscalCsv;

// New selectors for DOWNLOAD_FISCAL_XLSX
export const selectDownloadFiscalXlsxLoader = (state: TStoreState) =>
	selectFiscalReports(state).downloadFiscalXlsxLoader;

export const selectDownloadedFiscalXlsx = (state: TStoreState) =>
	selectFiscalReports(state).downloadedFiscalXlsx;

// New selectors for UPDATE_FISCAL_REPORT_PAYMENT
export const selectUpdateFiscalReportPaymentLoader = (state: TStoreState) =>
	selectFiscalReports(state).updateFiscalReportPaymentLoader;

// New selectors for UPDATE_FISCAL_REPORT_COMMENT
export const selectUpdateFiscalReportCommentLoader = (state: TStoreState) =>
	selectFiscalReports(state).updateFiscalReportCommentLoader;

// New selectors for EXPORT_FISCAL_XLSX
export const selectExportFiscalXlsxLoader = (state: TStoreState) =>
	selectFiscalReports(state).exportFiscalXlsxLoader;

export const selectExportedFiscalXlsx = (state: TStoreState) =>
	selectFiscalReports(state).exportedFiscalXlsx;
